/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Candidate } from '../models/Candidate';
import { request as __request } from '../core/request';

export class CandidatesService {

    /**
     * List candidates
     * @returns any Example response
     * @throws ApiError
     */
    public static async getCandidates({
        user,
        ids,
    }: {
        user?: string,
        ids?: string,
    }): Promise<{
        candidates: Array<Candidate>,
        nextPageToken?: string,
    }> {
        const result = await __request({
            method: 'GET',
            path: `/candidates`,
            query: {
                'user': user,
                'ids': ids,
            },
        });
        return result.body;
    }

    /**
     * Create candidate
     * @returns Candidate Created
     * @throws ApiError
     */
    public static async postCandidates({
        user,
        requestBody,
    }: {
        user?: string,
        requestBody?: Candidate,
    }): Promise<Candidate> {
        const result = await __request({
            method: 'POST',
            path: `/candidates`,
            query: {
                'user': user,
            },
            body: requestBody,
        });
        return result.body;
    }

    /**
     * Delete candidate
     * @returns void
     * @throws ApiError
     */
    public static async deleteCandidatesCandidateId({
        candidateId,
        user,
    }: {
        candidateId: string,
        user?: string,
    }): Promise<void> {
        const result = await __request({
            method: 'DELETE',
            path: `/candidates/${candidateId}`,
            query: {
                'user': user,
            },
            errors: {
                404: `Not Found`,
            },
        });
        return result.body;
    }

}